import { Fragment } from "react";
import { CommonGrid2 } from "./StyledComponents";
import {
  Avatar,
  Box,
  IconButton,
  Input,
  Typography,
  useMediaQuery,
} from "@mui/material";
import DeleteIco from "../../assets/icons/DeleteIco";
import { GetFileIcon } from "../../utils/constants";
import CommonButton from "../../component/Button";
import UploadIco from "../../assets/icons/UploadIco";
import { ShowSnackbar } from "../../redux/action/ShowSnackbar";
import { useDispatch } from "react-redux";


export function formatFileSize(bytes) {
  if (!bytes) return "0 Bytes";

  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  return (bytes / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
}

export default function CommonFileData({ handleRemoveFile, item, values }) {
  const lg = useMediaQuery("(min-width:767px)");

  return (
    <Fragment>
      {values?.map((file, index) => {
        const fileSize = file?.file?.[0]?.size || file?.size;

        return (
          <CommonGrid2
            item
            size={{
              xs: 12,
              md: item.uploadCustomSize || 4,
              sm: 6,
            }}
            key={index}
            border={"1px solid #EAECF0"}
            borderRadius={"8px"}
            padding={"10px"}
            display={"flex"}
            justifyContent={"space-between"}
            gap={"10px"}
            alignItems={"flex-start"}
          >
            <CommonGrid2 display={"flex"} gap={"12px"}>
              <Box display={"flex"}>
                <GetFileIcon file={file} width={"28px"} />
              </Box>
              <CommonGrid2 display={"flex"} flexDirection={"column"}>
                <Typography
                  variant={lg ? "p" : "subtitle2"}
                  color="#344054"
                  fontWeight={600}
                  overflow={"hidden"}
                  textOverflow={"ellipsis"}
                  whiteSpace={"nowrap"}
                >
                  {file?.file?.[0]?.name || file.name}
                </Typography>
                <Typography
                  variant={lg ? "p" : "subtitle2"}
                  color="#7F56D9"
                  fontWeight={600}
                  sx={{
                    wordBreak: "break-all",
                  }}
                >
                  {file?.file?.[0]?.file_name || file?.file_name}
                </Typography>
                {fileSize > 0 && (
                  <Typography
                    variant={lg ? "p" : "subtitle2"}
                    color="#475467"
                    fontWeight={500}
                  >
                    {formatFileSize(file?.file?.[0]?.size || file?.size)}
                  </Typography>
                )}
              </CommonGrid2>
            </CommonGrid2>
            <IconButton
              onClick={() => handleRemoveFile(index, item)}
              sx={{
                padding: "0px",
                cursor: "pointer",
              }}
            >
              <DeleteIco stroke={"#D80027"} size={!lg && "18px"} />
            </IconButton>
          </CommonGrid2>
        );
      })}
    </Fragment>
  );
}

export function CoversheetUpload({
  item,
  setFieldValue,
  values,
  disabled,
  customStyle,
  handleAnotherFunction = () => {},
  startIcon,
  margin,
  buttonLabel,
  handleCustomUpload,
  sx,
}) {
  const dispatch = useDispatch();
  return (
    <label
      htmlFor={`contained-${item.titleName}`}
      style={{
        width: "fit-content",
        margin:
          margin || values[item.titleName]?.length === 0
            ? "0px"
            : "10px 0px 0px",
        pointerEvents: disabled && "none",
      }}
    >
      <Input
        // accept="*"
        id={`contained-${item.titleName}`}
        multiple
        accept=".pdf,.doc,.docx"
        type="file"
        sx={{ display: "none" }}
        onChange={(e) => {
          // const append_file = e.target.files[0];
          // if (!append_file) return;

          // const file = Object.assign({}, append_file, {
          //   file_name: item?.file_name,
          // });
          const append_file = e.target.files[0];
          if (!append_file) return;

          const file = {
            name: append_file.name,
            size: append_file.size,
            type: append_file.type,
            lastModified: append_file.lastModified,
            file_name: item?.file_name,
            file: append_file,
          };
          if (!file) return;
          if (handleCustomUpload) {
            handleCustomUpload(e);
          } else {
            const allowedTypes = [
              "application/pdf",
              "application/msword",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ];
            if (!allowedTypes.includes(file.type)) {
              dispatch(
                ShowSnackbar({
                  open: true,
                  message: "Only PDF, DOC, DOCX files are allowed",
                  severity: "error",
                })
              );
              e.target.value = null;
              return;
            }
            const previousFiles = values[item.titleName] || [];
            const isDuplicate = previousFiles.some(
              (f) => f.name === file.name && f.size === file.size
            );
            if (isDuplicate) {
              dispatch(
                ShowSnackbar({
                  open: true,
                  message: "This file is already uploaded",
                  severity: "error",
                })
              );

              e.target.value = null;
              return;
            }
            if (item.single_upload) {
              setFieldValue(item.titleName, [file]);
              console.log(file, "sklfsknfksfklklsfkl");
              handleAnotherFunction();
              dispatch(
                ShowSnackbar({
                  open: true,
                  message: "File uploaded successfully",
                  severity: "success",
                })
              );
            } else {
              setFieldValue(item.titleName, [...previousFiles, file]);
              dispatch(
                ShowSnackbar({
                  open: true,
                  message: "File uploaded successfully",
                  severity: "success",
                })
              );
            }
          }
          e.target.value = null;
        }}
      />
      <CommonButton
        value={buttonLabel || "Upload"}
        variant="outlined"
        startIcon={startIcon || <UploadIco />}
        component="span"
        gap={"0px"}
        color="#344054"
        svg={true}
        disabled={disabled}
        customStyle={customStyle}
        sx={sx}
      />
    </label>
  );
}

export function GetWhiteLabelAvatar(org_logo_url,org_label,lg,label_color="#101828") {

  return (
    <CommonGrid2
      display={"flex"}
      gap={"10px"}
      alignItems="center"
    >
      {typeof org_logo_url === "string" ? (
        <Avatar
          src={org_logo_url}
          sx={{
            width: lg ? "40px" : "30px",
            height: lg ? "40px" : "30px",
          }}
        />
      ):(
        <Avatar
          sx={{
            width: "40px",
            height: "40px",
          }}
        >
          {org_label?.charAt(0)?.toUpperCase()}
        </Avatar>
      )}
      <Typography
        variant={lg ? "h5" : "subtitle3"}
        color={label_color}
        fontWeight={700}
      >
        {org_label}
      </Typography>
    </CommonGrid2>
  );
}